import {FileImageOutlined, FileJpgOutlined, FileOutlined, FilePdfOutlined} from '@ant-design/icons';
import React from 'react';

export const contentTypeIcons: Record<string, JSX.Element> = {
  'application/pdf': <FilePdfOutlined />,
  'image/jpeg': <FileJpgOutlined />,
  'image/png': <FileImageOutlined />,
  'image/tiff': <FileImageOutlined />
};

export const getContentTypeIcon = (contentType?: string | null): JSX.Element => {
  return contentTypeIcons[contentType!] || <FileOutlined />;
};
